<template>
  <div id="csContainer">
    <el-button class="getLatlong" size="small" type="primary" @click="getLatlong()" >鼠标获取经纬度</el-button>
    <el-button class="selectLight" size="small" type="primary" @click="selectLight()">选择高亮</el-button>
<!--    <el-button class="refresh" type="info" @click="refresh()" >刷新</el-button>-->
  </div>
</template>


<script>
    /*eslint-disable*/
    import * as Cesium from "cesium/Cesium";
    import widgets from "cesium/Widgets/widgets.css";
    import util from "../../components/util"
    export default {
        name: 'latlong',
        data(){
            return{
                isShow: false,
                viewer: null,
                handler:undefined,
                entity:null,
                entity1: null
            }
        },
        mounted(){
            this.init();
        },
        methods:{
            init(){
                let vm = util.getViewer("csContainer");
                this.viewer = vm;
                this.entity1 = this.viewer.entities.add({
                  position: Cesium.Cartesian3.fromDegrees(-75.59777,40.03883),
                  billboard: {
                    image: 'img/marker.png'
                }
              });
              this.viewer.trackedEntity = this.entity1;
            },
            getLatlong(){
                this.$message('右击结束功能');
                let viewer = this.viewer;
                let scene = viewer.scene;
                let handler = this.handler;
                let entity = viewer.entities.add({
                   label:{
                        name: "a",
                        show: false,
                        showBackground: true,
                        font: '14px monospace',
                        horizontalOrigin: Cesium.HorizontalOrigin.LEFT,
                        verticalOrigin: Cesium.VerticalOrigin.TOP,
                        pixelOffset: new Cesium.Cartesian2(15,0)
                   }
                });
                handler = new Cesium.ScreenSpaceEventHandler(scene.canvas);
                handler.setInputAction(function (movement) {
                    let cartesian = viewer.camera.pickEllipsoid(movement.endPosition,scene.globe.ellipsoid);
                    if(cartesian){
                        let cartographic = Cesium.Cartographic.fromCartesian(cartesian);
                        let long = Cesium.Math.toDegrees(cartographic.longitude).toFixed(5);
                        let lat = Cesium.Math.toDegrees(cartographic.latitude).toFixed(5);

                        entity.position = cartesian;
                        entity.label.show = true;
                        entity.label.text =
                            'Lon: ' + '   ' + long+ '\u00B0' +
                            '\nLat ' + '    ' + lat + '\u00B0';

                    }else {
                        entity.label.show = false;
                    }
                },Cesium.ScreenSpaceEventType.MOUSE_MOVE);
              handler.setInputAction(function (movement) {
                entity.label.show = false;
                handler.destroy();
              },Cesium.ScreenSpaceEventType.RIGHT_CLICK);
            },
          selectLight(){
             this.$message('右击结束功能');
              let viewer = this.viewer;
              let scene = viewer.scene;
              let entity = this.entity1;
              let handler = this.handler;
              // this.handler = new Cesium.ScreenSpaceEventHandler(scene.canvas);


              handler = new Cesium.ScreenSpaceEventHandler(scene.canvas);
              handler.setInputAction(function (movement) {
                  var pickedObject = scene.pick(movement.endPosition);
                  if(Cesium.defined(pickedObject)&&(pickedObject.id === entity)){
                    entity.billboard.scale = 2.0;
                    entity.billboard.color = Cesium.Color.YELLOW;
                  }else{
                    entity.billboard.scale = 1.0;
                    entity.billboard.color = Cesium.Color.WHITE;
                  }
              },Cesium.ScreenSpaceEventType.MOUSE_MOVE);
            handler.setInputAction(function (movement) {
              entity.billboard.scale = 1.0;
              entity.billboard.color = Cesium.Color.WHITE;
              handler.destroy();
            },Cesium.ScreenSpaceEventType.RIGHT_CLICK);

          },

        }
    }
</script>
<style scoped>
  .getLatlong {
    position: absolute;
    margin-left: 25px;
    margin-top:7px;
    z-index: 999;
  }
  .selectLight {
    position: absolute;
    margin-left: 155px;
    margin-top:7px;
    z-index: 999;
  }
  .refresh {
    position: absolute;
    margin-left: 820px;
    margin-top:10px;
    z-index: 999;
  }
  #csContainer {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }
</style>
